import defaultList from '../data/emailTemplates.json';

// Email templates live in site_content.email_templates, an object keyed by
// template type. Each template is { subject, greeting, body, button_text,
// footer_note }. The words in {curly brackets} are filled in per customer
// by supabase/functions/_shared/email.ts (step 14).

export var TEMPLATE_FIELDS = ['subject', 'greeting', 'body', 'button_text', 'footer_note'];

export var TEMPLATE_TYPES = [
  'abandoned_cart_1',
  'abandoned_cart_2',
  'order_confirmation',
  'shipping',
  'delivery_followup',
  'order_cancellation',
];

export var TEMPLATE_LABELS = {
  abandoned_cart_1: 'Abandoned cart (1 hour)',
  abandoned_cart_2: 'Abandoned cart (24 hours)',
  order_confirmation: 'Order confirmation',
  shipping: 'Shipping notification',
  delivery_followup: 'Delivery follow-up',
  order_cancellation: 'Order cancellation',
};

// What each {variable} becomes, in plain words for Andre.
export var VARIABLE_HELP = {
  customer_name: 'The customer’s name',
  product_name: 'The bag they ordered or left in their bag',
  product_variant: 'The size or colour they chose',
  product_price: 'The price, e.g. $450.00',
  order_number: 'Their order number, e.g. AM-00138',
  tracking_number: 'The tracking number you enter when marking it shipped',
  cart_url: 'A link that refills their bag so they can finish ordering',
  promo_code: 'Your reminder promo code (if switched on)',
  unsubscribe_url: 'A link to stop these reminder emails',
};

// The variables each template may use (see the plan's Contracts).
export var TEMPLATE_VARIABLES = {
  abandoned_cart_1: ['customer_name', 'product_name', 'product_variant', 'product_price', 'cart_url', 'unsubscribe_url'],
  abandoned_cart_2: ['customer_name', 'product_name', 'product_variant', 'product_price', 'cart_url', 'promo_code', 'unsubscribe_url'],
  order_confirmation: ['customer_name', 'product_name', 'product_variant', 'product_price', 'order_number'],
  shipping: ['customer_name', 'product_name', 'product_variant', 'order_number', 'tracking_number'],
  delivery_followup: ['customer_name', 'product_name', 'product_variant', 'order_number', 'unsubscribe_url'],
  order_cancellation: ['customer_name', 'product_name', 'product_variant', 'product_price', 'order_number'],
};

function pickFields(t) {
  var out = {};
  TEMPLATE_FIELDS.forEach(function(f) { out[f] = t && typeof t[f] === 'string' ? t[f] : ''; });
  return out;
}

// The starting wording from src/data/emailTemplates.json, keyed by type.
// The JSON calls the shipping email "shipping_notification"; the contract calls it "shipping".
export function defaultEmailTemplates() {
  var out = {};
  defaultList.forEach(function(t) {
    var type = t.type === 'shipping_notification' ? 'shipping' : t.type;
    out[type] = pickFields(t);
  });
  return out;
}

// Saved templates on top of the defaults, so every type always has every field.
export function mergeEmailTemplates(saved) {
  var defaults = defaultEmailTemplates();
  var out = {};
  var source = saved && typeof saved === 'object' && !Array.isArray(saved) ? saved : {};
  TEMPLATE_TYPES.forEach(function(type) {
    var base = defaults[type] || pickFields(null);
    var mine = source[type] && typeof source[type] === 'object' ? source[type] : {};
    var merged = {};
    TEMPLATE_FIELDS.forEach(function(f) { merged[f] = typeof mine[f] === 'string' ? mine[f] : base[f]; });
    out[type] = merged;
  });
  // Keep any other template types already saved (never drop Andre's data).
  Object.keys(source).forEach(function(type) {
    if (!out[type] && source[type] && typeof source[type] === 'object') out[type] = pickFields(source[type]);
  });
  return out;
}

// {words} in the template that this email can't fill in, e.g. a typo like
// {custmer_name} or {tracking_number} in an abandoned-cart email.
export function unknownVariables(template, type) {
  var allowed = TEMPLATE_VARIABLES[type] || [];
  var found = [];
  TEMPLATE_FIELDS.forEach(function(f) {
    var text = (template && template[f]) || '';
    var re = /\{([^{}\s]+)\}/g;
    var m;
    while ((m = re.exec(text)) !== null) {
      if (allowed.indexOf(m[1]) < 0 && found.indexOf(m[1]) < 0) found.push(m[1]);
    }
  });
  return found;
}
